import { toValue, computed } from 'vue';
import type { MaybeRefOrGetter } from 'vue';
import { useFetch } from '#app/composables/fetch';
import type { NestedCategoryItem } from '~~/server/api/kiwi_user/recipe_categories/navigation';

// NOTE: レシピカテゴリナビゲーションのデータをキャッシュ付きで取得する
// keyオプションで明示的にキャッシュキーを指定し、同一のcategoryIdに対してキャッシュを共有する
export function useRecipeCategoriesNavigation(
  categoryId: MaybeRefOrGetter<number | undefined>,
) {
  // NOTE: キャッシュキーをcomputedで動的に生成
  // categoryIdが変更されるとキャッシュキーも更新される
  const cacheKey = computed(
    () => `recipe-categories-navigation-${toValue(categoryId) ?? 'root'}`,
  );

  return useFetch<NestedCategoryItem[]>(
    '/api/kiwi_user/recipe_categories/navigation',
    {
      key: cacheKey,
      query: {
        ct: categoryId,
      },
    },
  );
}
